export default "__VITE_ASSET__D3Yg6lMg__"